/** Prefijos más largos primero. */
export const ROUTE_RECURSO_PREFIXES: ReadonlyArray<{ prefix: string; recurso: string }> = [
  { prefix: '/app/conductores/solicitudes', recurso: 'solicitudes' },
  { prefix: '/app/gps-panico/bitacora', recurso: 'gps_panico.bitacora' },
  { prefix: '/app/cobros/estado-cuenta', recurso: 'cobros.estado_cuenta' },
  { prefix: '/app/cortes/pendientes', recurso: 'cortes.pendientes' },
  { prefix: '/app/facturacion/bitacora', recurso: 'facturacion.bitacora' },
  { prefix: '/app/facturacion/emisores', recurso: 'facturacion.emisores' },
  { prefix: '/app/facturacion/configuracion-pac', recurso: 'facturacion.pac' },
  { prefix: '/app/catalogos/categorias-vehiculo', recurso: 'catalogos.categorias_viaje' },
  { prefix: '/app/catalogos/categorias-viaje', recurso: 'catalogos.categorias_viaje' },
  { prefix: '/app/catalogos/tipos-vehiculo', recurso: 'catalogos.categorias_viaje' },
  { prefix: '/app/catalogos/zonas', recurso: 'catalogos.zonas' },
  { prefix: '/app/catalogos/motivos-cancelacion', recurso: 'catalogos.motivos_cancelacion' },
  { prefix: '/app/catalogos/motivos-evaluacion', recurso: 'catalogos.motivos_evaluacion' },
  { prefix: '/app/catalogos/motivos-bloqueo', recurso: 'catalogos.motivos_bloqueo' },
  { prefix: '/app/catalogos/tipos-documento', recurso: 'catalogos.tipos_documento' },
  { prefix: '/app/catalogos/documentos-requeridos', recurso: 'catalogos.tipos_documento' },
  { prefix: '/app/catalogos/taximetros', recurso: 'catalogos.taximetros' },
  { prefix: '/app/catalogos/tipos-viaje-sat', recurso: 'catalogos.tipos_viaje_sat' },
  { prefix: '/app/catalogos/parametros-generales', recurso: 'catalogos.parametros' },
  { prefix: '/app/catalogos/parametros', recurso: 'catalogos.parametros' },
  { prefix: '/app/catalogos/plantillas-notificaciones', recurso: 'catalogos.plantillas' },
  { prefix: '/app/catalogos/terminos-privacidad', recurso: 'catalogos.terminos' },
  { prefix: '/app/dashboard', recurso: 'dashboard' },
  { prefix: '/app/conductores', recurso: 'conductores' },
  { prefix: '/app/clientes', recurso: 'clientes' },
  { prefix: '/app/vehiculos', recurso: 'vehiculos' },
  { prefix: '/app/gps-panico', recurso: 'gps_panico' },
  { prefix: '/app/viajes', recurso: 'viajes' },
  { prefix: '/app/cobros', recurso: 'cobros' },
  { prefix: '/app/cortes', recurso: 'cortes' },
  { prefix: '/app/facturacion', recurso: 'facturacion' },
  { prefix: '/app/tarifas', recurso: 'tarifas' },
  { prefix: '/app/reportes', recurso: 'reportes' },
  { prefix: '/app/catalogos', recurso: 'catalogos' },
  { prefix: '/app/auditoria', recurso: 'auditoria' },
  { prefix: '/app/roles', recurso: 'roles' },
  { prefix: '/app/usuarios', recurso: 'usuarios' },
  { prefix: '/app/design-system', recurso: 'dev.design_system' }
];

export function recursoFromUrl(url: string): string | null {
  const path = url.split('?')[0].replace(/\/+$/, '') || '/';
  for (const row of ROUTE_RECURSO_PREFIXES) {
    if (path === row.prefix || path.startsWith(`${row.prefix}/`)) {
      return row.recurso;
    }
  }
  return null;
}

export const CATALOGO_CARD_RECURSO: Record<string, string> = {
  '/app/catalogos/categorias-vehiculo': 'catalogos.categorias_viaje',
  '/app/catalogos/zonas': 'catalogos.zonas',
  '/app/catalogos/tipos-documento': 'catalogos.tipos_documento',
  '/app/catalogos/taximetros': 'catalogos.taximetros',
  '/app/catalogos/motivos-cancelacion': 'catalogos.motivos_cancelacion',
  '/app/catalogos/motivos-evaluacion': 'catalogos.motivos_evaluacion',
  '/app/catalogos/motivos-bloqueo': 'catalogos.motivos_bloqueo',
  '/app/catalogos/tipos-viaje-sat': 'catalogos.tipos_viaje_sat',
  '/app/catalogos/parametros-generales': 'catalogos.parametros',
  '/app/catalogos/plantillas-notificaciones': 'catalogos.plantillas',
  '/app/catalogos/terminos-privacidad': 'catalogos.terminos'
};
